import { IFeatureToggleResponse, IFeatureToggleResponseV2 } from './FeatureToggleResponse'
import { commonApiClient } from '../../../util/apiClient/commonApiClient'

export declare interface IFeatureToggleApi {
  getFeatureToggle(): Promise<string>
  getFeatureToggleV2(): Promise<string[]>
}

export const featureToggleApi: IFeatureToggleApi = {
  async getFeatureToggle(): Promise<string> {
    const response = await commonApiClient.post<IFeatureToggleResponse>('/frontEndToggle')
    return response.data.toggles
  },
  async getFeatureToggleV2(): Promise<string[]> {
    const response = await commonApiClient.post<IFeatureToggleResponseV2>('/frontEndToggle/v2')
    return response.data.toggles
  },
}

export const mockFeatureToggleApi: IFeatureToggleApi = {
  async getFeatureToggle(): Promise<string> {
    return JSON.stringify({
      disableCurrencyDisplay: 'true',
      disableLeaveGameBtn: 'true',
      disableLeaveGameBtnByRedirectUrlNotExisted: 'false',
      disableRTPDisplay: 'true',
      disableFunkyGameLogo: 'false',
      disableHistoryList: 'false',
      disableChangePose: 'false',
      disableTutorial: 'false',
      disableBuyBonus: 'false',
    })
  },
  async getFeatureToggleV2(): Promise<string[]> {
    return [
      'enableSkipOngoingReplay',
      'displayCurrency',
      'displayFunkyLogo',
      'displayRefNo',
      'enableAutoPlay',
      'enableBackBtn',
      'enableBetHistory',
      'enableBuyBonus',
      'enableChangePose',
      'enableTurbo',
      'enableVideoRecord',
      'enableBackButtonForRedirectUrl',
      'displayRTPGameInfo',
      'enableReelTableClickForSpin',
      'enableSlamStop',
      'enableSpacebarSpin',
    ]
  },
}
